import { render, staticRenderFns } from "./ImagenComponent.vue?vue&type=template&id=0f4ee299&"
import script from "./ImagenComponent.vue?vue&type=script&lang=js&"
export * from "./ImagenComponent.vue?vue&type=script&lang=js&"
import style0 from "./ImagenComponent.vue?vue&type=style&index=0&id=0f4ee299&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports